import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import Headline5 from '../Typography/Heading/Headline5';
import Subtitle2, { Subtitle2Properties } from '../Typography/SubTitle2';
import breakpoints from '../Theme/breakpoints';

const LatestJobsContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LatestJobsListItem = styled.li`
  padding: 16px 0;

  @media (min-width: ${breakpoints.md}px) {
    padding: 12px 8px;
  }
`;

export const LatestJobsHeadline = styled(Headline5)`
  && {
    @media (min-width: ${breakpoints.md}px) {
      font-size: ${({ theme }) => theme.sizes.h6};
    }
  }
`;

const LatestJobsSubtitle = styled(
  (properties: Subtitle2Properties) => <Subtitle2 {...properties} />,
)`
  display: block;
  font-size: ${({ theme }) => theme.sizes.subtitle1};
`;

const latestJobsPropertyTypes = {
  title: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  companyName: PropTypes.string.isRequired,
};

type LatestJobsContentProperties = InferProps<
  typeof latestJobsPropertyTypes
>;

const LatestJobsContent = ({
  title,
  city,
  companyName,
}: LatestJobsContentProperties) => (
  <LatestJobsContentWrapper>
    <LatestJobsHeadline tag="span">
      {title}
    </LatestJobsHeadline>
    <LatestJobsSubtitle>
      {city}
      {' - '}
      {companyName}
    </LatestJobsSubtitle>
  </LatestJobsContentWrapper>
);

export default LatestJobsContent;
